<!-- Footer -->
<footer id="ftr" class="modern-footer">
  <!-- Footer Links -->
  <div class="footer-content">
    <div class="container">
      <!-- Grid row -->
      <div class="row">

        <!-- Company Info Column -->
        <div class="col-md-4 mb-4">
          <div class="footer-section">
            <h6 class="footer-heading">{{compName}}</h6>
            <div class="heading-underline"></div>
            <p class="footer-text">{{address}}</p>
          </div>
        </div>

        <!-- Useful Links Column -->
        <div class="col-md-8 mb-4">
          <div class="footer-section">
            <h6 class="footer-heading">Useful Links</h6>
            <div class="heading-underline"></div>
            <div class="links-container">
              <div class="row">
                <div class="col-md-4" *ngFor="let group of chunkedLinks">
                  <div class="link-group">
                    <p *ngFor="let link of group" class="footer-link">
                      <a [href]="link.value" target="_blank">
                        <span class="link-icon">→</span>
                        {{ link.key }}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Copyright -->
  <div class="footer-bottom">
    <div class="container">
      <div class="copyright-text">
        <span>&copy; {{Year}} <a href="https://kanbiosys.com/" target="_blank" class="company-link">Kan Biosys</a>. All rights reserved</span>
        <span class="separator">|</span>
        <span>Powered by DMS - <a href="https://primustechsys.com/" target="_blank" class="company-link">PRIMUS Techsystems</a></span>
      </div>
    </div>
  </div>
</footer>
<!-- Footer -->